RivalIQ.module('graph.mixins', function (mixins, App, Backbone, Marionette, $, _) {

    'use strict';

    const Y_TICK_LABEL_MIN_WIDTH = 22;
    const AXIS_LABEL_SCALE = 2.25;

    mixins.CalculatedMargin = {
        getYMax: _.noop,

        getMargin: function () {
            const me = this;
            const margin = RivalIQ.graph.Block.prototype.getMargin.apply(me, arguments);
            return _.defaults({
                left: me.getLeftMargin(),
                bottom: me.getBottomMargin(margin)
            }, margin);
        },

        getLeftMargin: function () {
            const me = this;

            const yMax = me.getYMax();
            const yMin = me.getYMin();
            const yMaxTickLabelWidth = me.getLongestYAxisTickLabelWidth(yMin, yMax);
            const leftMargin = Math.max(Math.ceil(yMaxTickLabelWidth), Y_TICK_LABEL_MIN_WIDTH);

            const computedLeftMargin = (me.hasAxisLabel('y') ? leftMargin * AXIS_LABEL_SCALE : leftMargin + 5);
            const minLeftMargin = me.getOption('minLeftMargin') || 0;

            return Math.max(computedLeftMargin, minLeftMargin);
        },

        getBottomMargin: function (margin) {
            const me = this;
            const bottomMargin = _.get(margin, 'bottom', 0);
            return (me.hasAxisLabel('x') ? bottomMargin * AXIS_LABEL_SCALE : bottomMargin);
        },

        // TODO this should go away with a unification of metric(s) property
        _getMetric: function () {
            const me = this;

            let metric;
            const concept = me.getOption('concept');

            if (concept) {
                metric = (_.isArray(concept) ? _.head(concept) : concept);
            } else {
                const metrics = me.getOption('metrics');
                if (metrics) {
                    metric = metrics.first();
                }
            }

            return metric;
        },

        /**
         * Gets the pixel width of a y-axis tick label given a value.
         * @param {Number} tickValue A value on the y-axis.
         * @param {Function} [formatter] An optional formatting function.
         * @returns {Number} The pixel width of the formatted tick value.
         */
        getYAxisTickLabelWidth: function (tickValue, formatter) {
            const me = this;
            const metric = me._getMetric();
            const yAxisTickValueFormatted = (_.isFunction(formatter) ? formatter(tickValue) : metric.axisFormat(tickValue, {
                tick: true
            }));
            const boundingBox = RivalIQ.graph.utils.getTextBoundingBox(yAxisTickValueFormatted);
            return boundingBox.width;
        },

        getLongestYAxisTickLabelWidth: function (yMin, yMax) {
            const me = this;
            const metric = me._getMetric();
            return _.max(_.map(me._getYTickValues(yMin, yMax, metric), _.bind(me.getYAxisTickLabelWidth, me)));
        }
    };

});
